import {
  gql 
} from "@apollo/client";

export const GET_CUSTOMER_INFLUENCER = gql`
    query GetCustomerInfluencer {
        customer {
            influencer {
                paypal_account
                reference_link
                commission_rate
                total_commission
                received_commission
                unreceived_commission
                link_clicks
                promoted_order
                commission_detail {
                    order_date
                    order_number
                    grand_total
                    commission_rate
                    commission_amount
                    status
                }
                commission_bill {
                    payment_date
                    commission_amount
                    payment_method
                    status
                }
            }
        }
    }
`;

export const SAVE_INFLUENCER = gql`
    mutation SaveInfluencer($paypal_account: String!) {
        saveInfluencer(input: { paypal_account: $paypal_account }) {
            code
            message
            content
        }
    }
`;
export default {
  saveInfluencerMutation: SAVE_INFLUENCER,
  getCustomerInfluencerQuery: GET_CUSTOMER_INFLUENCER
};
